import React, { useEffect, useState } from 'react';
import { useAppState } from '../../contexts/AppStateContext';
import { DEMO_DATE } from '../../data/demo';
import { eventTypeLabels } from '../../data/labels';
import { EventType } from '../../types/family';
import { Sheet } from '../ui/Sheet';
import { Button } from '../ui/Button';
import { Chip, Field, Toggle } from '../ui/Form';
export function AddEventSheet({
  open,
  onClose
}: {
  open: boolean;
  onClose: () => void;
}) {
  const {
    activeMembers,
    viewer,
    addEvent
  } = useAppState();
  const [title, setTitle] = useState('');
  const [date, setDate] = useState(DEMO_DATE);
  const [start, setStart] = useState('17.00');
  const [end, setEnd] = useState('');
  const [type, setType] = useState<EventType>('osebno');
  const [who, setWho] = useState<string[]>([viewer.id]);
  const [needsDriver, setNeedsDriver] = useState(false);
  const [repeat, setRepeat] = useState('');
  const [reminder, setReminder] = useState('30 min prej');
  useEffect(() => {
    if (!open) return;
    setTitle('');
    setDate(DEMO_DATE);
    setStart('17.00');
    setEnd('');
    setType('osebno');
    setWho([viewer.id]);
    setNeedsDriver(false);
    setRepeat('');
  }, [open, viewer.id]);
  const valid = title.trim() && /^\d{1,2}[.:]\d{2}$/.test(start);
  return <Sheet open={open} onClose={onClose} title="Nov dogodek" subtitle="Shrani se v družinski koledar aplikacije" footer={<Button className="w-full" disabled={!valid} onClick={() => {
    addEvent({
      title: title.trim(),
      date,
      start: start.replace(':', '.'),
      end: end || undefined,
      type,
      participantIds: who,
      needsDriver,
      repeat: repeat || undefined,
      reminder
    });
    onClose();
  }} data-id="element-5" data-mp="3uimm4uzgtbi2">
          Dodaj dogodek
        </Button>} data-id="element-4" data-mp="2xtf0lmyuj2e5">
      <div className="space-y-4" data-id="element-6" data-mp="2a4c79huunl3t">
        <Field label="Naziv" data-id="element-7" data-mp="2a17wu2qsjt4p">{id => <input id={id} className="field" value={title} onChange={e => setTitle(e.target.value)} placeholder="npr. Tekma, nastop, pregled" data-id="element-8" data-mp="253ybay6iw1m5" />}</Field>
        <div className="grid grid-cols-3 gap-3" data-id="element-9" data-mp="26mg2xwhm3lkm">
          <Field label="Datum" data-id="element-10" data-mp="2bl9j5woa9qoh">{id => <input id={id} type="date" className="field" value={date} onChange={e => setDate(e.target.value)} data-id="element-11" data-mp="2bjezsmsnu6mi" />}</Field>
          <Field label="Začetek" data-id="element-12" data-mp="1xkox8rn2neqr">{id => <input id={id} className="field" value={start} onChange={e => setStart(e.target.value)} placeholder="17.00" data-id="element-13" data-mp="21ma8k8jyjkyu" />}</Field>
          <Field label="Konec" data-id="element-14" data-mp="1nu443jq632f8">{id => <input id={id} className="field" value={end} onChange={e => setEnd(e.target.value)} placeholder="neobvezno" data-id="element-15" data-mp="1ntucjrph4n7f" />}</Field>
        </div>
        <div data-id="element-16" data-mp="1dx97x7hd9e44">
          <p className="mb-1.5 text-sm font-bold" data-id="element-17" data-mp="1dxr0nu4tla7a">Vrsta</p>
          <div className="flex flex-wrap gap-2" data-id="element-18" data-mp="1dv4sbsa3uqo0">
            {(Object.keys(eventTypeLabels) as EventType[]).filter(t => t !== 'sluzba').map(t => <Chip key={t} active={type === t} onClick={() => setType(t)} data-id="element-19" data-mp="14xcg4wzojz4u">
                {eventTypeLabels[t]}
              </Chip>)}
          </div>
        </div>
        <div data-id="element-20" data-mp="q92lp4f7c102">
          <p className="mb-1.5 text-sm font-bold" data-id="element-21" data-mp="qanf2qps5dwc">Udeleženci (prazno = vsa družina)</p>
          <div className="flex flex-wrap gap-2" data-id="element-22" data-mp="lb15qsd2ohst">
            {activeMembers.map(m => <Chip key={m.id} color={m.color} active={who.includes(m.id)} onClick={() => setWho(w => w.includes(m.id) ? w.filter(x => x !== m.id) : [...w, m.id])} data-id="element-23" data-mp="zasby6xcktw9">
                {m.name}
              </Chip>)}
          </div>
        </div>
        <div className="grid grid-cols-2 gap-3" data-id="element-24" data-mp="196djslp3kodx">
          <Field label="Ponavljanje" data-id="element-25" data-mp="14a59pmprbldm">{id => <input id={id} className="field" value={repeat} onChange={e => setRepeat(e.target.value)} placeholder="npr. vsak torek" data-id="element-26" data-mp="148u37f4xfzit" />}</Field>
          <Field label="Opomnik" data-id="element-27" data-mp="1dzf1t2klp41q">
            {id => <select id={id} className="field" value={reminder} onChange={e => setReminder(e.target.value)} data-id="element-28" data-mp="1dzyiyh2ffoep">
                <option data-id="element-29" data-mp="1rwv5w7ffclqb">Brez</option>
                <option data-id="element-30" data-mp="1n0d5fjr4n9js">15 min prej</option>
                <option data-id="element-31" data-mp="1n1oaro080pd0">30 min prej</option>
                <option data-id="element-32" data-mp="3hgbjc2a8a73n">1 h prej</option>
                <option data-id="element-33" data-mp="3hfa6ptdkdcjt">Dan prej</option>
              </select>}
          </Field>
        </div>
        <Toggle checked={needsDriver} onChange={setNeedsDriver} label="Potreben prevoz" hint="Pokaže se v odprtih dogovorih, dokler nekdo ne prevzame." data-id="element-34" data-mp="3mdlkugaw697u" />
      </div>
    </Sheet>;
}